// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC4sMtnMNV0gLe8fd-FN0jJZ-AZl0nC4oo",
  authDomain: "kgsa-auth.firebaseapp.com",
  projectId: "kgsa-auth",
  storageBucket: "kgsa-auth.firebasestorage.app",
  messagingSenderId: "552253786902",
  appId: "1:552253786902:web:969ac90732d73f4653de37",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
